import React, { useRef, useState, useEffect } from "react";
import tw from "twin.macro";
import MAIMotionVideo from "videos/MAIMotion.mp4";

const Section = tw.div`w-full relative bg-gray-900 max-w-screen-lg mx-auto`;
const VideoWrapper = tw.div`relative w-full overflow-hidden`;
const StyledVideo = tw.video`w-full h-auto block`;
const PlayButtonContainer = tw.div`absolute inset-0 flex items-center justify-center z-10`;
const PlayCircle = tw.div`w-24 h-24 bg-white rounded-full flex items-center justify-center cursor-pointer shadow-lg transition-transform duration-300 hover:scale-105`;

const LandingPageVideo = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handlePause = () => setIsPlaying(false);
        const handlePlay = () => setIsPlaying(true);

        video.addEventListener("pause", handlePause);
        video.addEventListener("play", handlePlay);

        return () => {
            video.removeEventListener("pause", handlePause);
            video.removeEventListener("play", handlePlay);
        };
    }, []);

    const handlePlayClick = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    return (
        <Section>
            <VideoWrapper>
                <StyledVideo
                    ref={videoRef}
                    preload="auto"
                    loop
                    muted
                    controls
                    playsInline
                >
                    <source src={MAIMotionVideo} type="video/mp4" />
                </StyledVideo>

                {!isPlaying && (
                    <PlayButtonContainer>
                        <PlayCircle onClick={handlePlayClick}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                viewBox="0 0 24 24"
                                fill="black"
                            >
                                <path d="M8 5v14l11-7z" />
                            </svg>
                        </PlayCircle>
                    </PlayButtonContainer>
                )}
            </VideoWrapper>
        </Section>
    );
};

export default LandingPageVideo;
